import React, { useContext } from 'react'
import Button from '@Components/Buttons/Button'
import { PublisherFormType } from '@App/enum/publisher-form-type'
import { StoresContext } from '@App/contexts'
import PublisherSearchResultsTable from '@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherSearchResultsTable'

import { PublisherModelWithWorksCount } from '@Entities/work/publisher-model-with-works-count'
import { PublisherSearchStoreLike } from '@App/stores/search/publisher-search-store-like'

interface PublisherAfterFindFormProps {
    itemWasAdded?: (publisherName: string) => boolean | undefined
    setFinedPublisherToDraft: (publisher: PublisherModelWithWorksCount) => void
    addPublisherToDraft: (() => void) | undefined
    topLevelClass: string
    searchStore?: PublisherSearchStoreLike
}

const PublisherAfterFindForm = (props: PublisherAfterFindFormProps) => {
    const { publisherSearchStore, publisherStepStore } = useContext(StoresContext)
    const { itemWasAdded, setFinedPublisherToDraft, addPublisherToDraft, topLevelClass, searchStore } = props
    const resolvedSearchStore = searchStore ?? publisherSearchStore
    const searchResult = resolvedSearchStore.publisherSearchModel

    return (
        <>
            <div className={topLevelClass}>
                <h2>
                    {searchResult && searchResult.results.length > 1
                        ? 'We already have publishers with those details:'
                        : 'We already have a publisher with those details:'}
                </h2>
                {searchResult && searchResult.results.length > 0 ? (
                    <PublisherSearchResultsTable
                        searchStore={resolvedSearchStore}
                        itemWasAdded={itemWasAdded}
                        setFoundPublisherToDraft={setFinedPublisherToDraft}
                    />
                ) : null}
                <p className="cant-find-title-after-find">Not the correct publisher?</p>
                <div className="buttons-area">
                    <Button
                        mainColor
                        type="primary"
                        onClick={() => publisherStepStore.setFormType(PublisherFormType.create)}
                    >
                        Back to create
                    </Button>
                    <Button mainColor type="primary" onClick={addPublisherToDraft}>
                        Confirm &amp; create new
                    </Button>
                </div>
            </div>
        </>
    )
}

export default PublisherAfterFindForm
